import React from "react";

type Props = {
  width: number;
  height: number;
};
export const AdTOPSliderSVG: React.FC<Props> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 27 21"
      fill="currentColor"
      opacity="0.6"
    >
      <path
        id="パス_2053"
        data-name="パス 2053"
        d="M24.75-19.5H5.25A2.25,2.25,0,0,0,3-17.25v.75H2.25A2.25,2.25,0,0,0,0-14.25V-.75A2.25,2.25,0,0,0,2.25,1.5h19.5A2.25,2.25,0,0,0,24-.75V-1.5h.75A2.25,2.25,0,0,0,27-3.75v-13.5A2.25,2.25,0,0,0,24.75-19.5ZM22.5-.75a.751.751,0,0,1-.75.75H2.25A.751.751,0,0,1,1.5-.75v-13.5A.751.751,0,0,1,2.25-15H3V-3.75A2.25,2.25,0,0,0,5.25-1.5H22.5Zm3-3a.751.751,0,0,1-.75.75H5.25a.751.751,0,0,1-.75-.75v-13.5A.751.751,0,0,1,5.25-18h19.5a.751.751,0,0,1,.75.75ZM8.25-11.625a2.625,2.625,0,0,0,2.625-2.625A2.625,2.625,0,0,0,8.25-16.875,2.625,2.625,0,0,0,5.625-14.25,2.625,2.625,0,0,0,8.25-11.625Zm0-3.75A1.126,1.126,0,0,1,9.375-14.25,1.126,1.126,0,0,1,8.25-13.125,1.126,1.126,0,0,1,7.125-14.25,1.126,1.126,0,0,1,8.25-15.375Zm11.3,1.079a1.125,1.125,0,0,0-1.591,0L13.5-9.841,12.045-11.3a1.125,1.125,0,0,0-1.591,0L6.33-7.17a1.292,1.292,0,0,0-.33.8v1.312a.563.563,0,0,0,.562.562H23.437A.563.563,0,0,0,24-5.062V-9.375a1.125,1.125,0,0,0-.329-.8ZM22.5-6H7.5v-.22l3.75-3.75L13.5-7.72l5.25-5.25L22.5-9.22Z"
        transform="translate(0 19.5)"
      />
    </svg>
  );
};
